<script setup lang="ts">
import { pushProductCategoryClickCtaEvent } from "~/utils/analytics/clickCta"
import type { CategoriesProps } from "./Categories.props"
import InfoText from "~/components/InfoText.server.vue"

const props = defineProps<CategoriesProps>()

const expandCategories = ref(false)
const showAllBtn = ref(false)

const categories = computed(() => {
  if (!import.meta.client) return props.suggestions

  if (expandCategories.value) {
    showAllBtn.value = true
    return props.suggestions.slice()
  } else if (props.suggestions.length > 10) {
    showAllBtn.value = true
    return props.suggestions.slice(0, 10)
  } else {
    showAllBtn.value = props.suggestions.length > 10
    return props.suggestions.slice()
  }
})

const handleCategoryClick = (label: string) => {
  if (expandCategories) pushProductCategoryClickCtaEvent(label)
}

const handleExpandCategoriesClick = (label: string) => {
  expandCategories.value = !expandCategories.value

  if (!expandCategories.value) {
    return
  }

  pushProductCategoryClickCtaEvent(label)
}
</script>

<template>
  <div class="suggestion-categories padded pb-0 pt-4">
    <h1 class="mammoth-bold" :class="{ ' pb-4': categories.length }">
      {{ title }}
    </h1>

    <InfoText v-if="infoText" :text="infoText" />

    <div
      v-if="categories.length"
      class="-mx-4 flex gap-4 px-4 py-1 pb-5 md:mx-0 md:flex-wrap md:px-0"
      :class="[
        expandCategories ? 'flex-wrap' : 'overflow-x-scroll  md:overflow-auto '
      ]"
    >
      <h2 v-for="(item, index) in categories">
        <UtilsButton
          class="
            transform-gpu
            whitespace-nowrap
            drop-shadow-01
            md:whitespace-normal
          "
          :key="`categories${index}`"
          theme="tag"
          :text="item.text"
          :path="`${item.path}`"
          @click="() => handleCategoryClick(item.text)"
        />
      </h2>

      <UtilsButton
        class="whitespace-nowrap [&>span]:no-underline"
        v-if="showAllBtn"
        theme="link-green"
        :text="
          !expandCategories
            ? 'Esplora tutte le categorie'
            : 'Mostra meno categorie'
        "
        :textUnderline="false"
        @click="() => handleExpandCategoriesClick('Esplora tutte le categorie')"
      >
        <template #icon>
          <UtilsIcon
            name="ArrowDownSmall.svg"
            :class="[{ 'rotate-180': expandCategories }]"
            fetch-priority="high"
            :preload="true"
          />
        </template>
      </UtilsButton>
    </div>
  </div>
</template>
